import { envConfig } from "../config/envConfigs";
import { controller } from "./controller";

@controller
export default class XaButtonElement extends HTMLElement {
  open(): void {
    const y = screen.height - 612;
    const x = screen.width - 415;
    const newWindow = window.open("", "Xfinity Assistant", `top=${y},left=${x},width=375,height=582`);
    if (newWindow) {
      newWindow.opener = null;
      newWindow.location.replace(envConfig.urls["xfinity-assistant"]);
    }
  }
}

declare global {
  interface Window {
    XaButtonElement: typeof XaButtonElement;
  }
  interface HTMLElementTagNameMap {
    "xa-button": XaButtonElement;
  }
}

if (!window.customElements.get("xa-button")) {
  window.XaButtonElement = XaButtonElement;
  window.customElements.define("xa-button", XaButtonElement);
}
